/**
 * "The browser could not fetch a code-split chunk." Every engine words it
 * differently, and none of them exposes a code or an error subclass, so string
 * matching is the only handle we get.
 *
 * The cause is usually a deploy: `index.html` pins hashed filenames, and the
 * next deploy replaces the whole directory (`apps/app/Dockerfile`), so a tab
 * that has been open across one asks for a chunk that no longer exists. It is
 * not proof of that on its own though — offline reads the same. See
 * `lazy-page.ts` for what we do with the answer.
 */
const CHUNK_LOAD_MESSAGES = [
  // Chromium
  'Failed to fetch dynamically imported module',
  // Firefox
  'error loading dynamically imported module',
  // Safari
  'Importing a module script failed',
  // Vite's preload helper, when the stylesheet beside the chunk is the 404
  'Unable to preload CSS for',
];

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return CHUNK_LOAD_MESSAGES.some((candidate) => message.includes(candidate));
}
